
// This jQuery import hell is necessary for the plugins to stay active after the import.
// Old bower exports don't play well with vite sadly
import jQuery from '@/legacy/plugin/bootstrap-plugs/bootstrap'
window.$ = window.jQuery = jQuery

import { Bloodhound } from '@/legacy/plugin/typeahead/typeahead.bundle.js'
import swal from 'sweetalert' // Currently running version one, we should look into updating to version 2

import '@fortawesome/fontawesome-free/scss/fontawesome.scss';
import '@fortawesome/fontawesome-free/scss/brands.scss';
import '@fortawesome/fontawesome-free/scss/regular.scss';
import '@fortawesome/fontawesome-free/scss/solid.scss';

import * as _ from 'lodash'
import * as Waves from 'node-waves'
import * as accounting from 'accounting-js'
import wNumb from 'wnumb'

window.Bloodhound = Bloodhound
window._ = _

window.swal = swal
window.Waves = Waves

window.accounting = accounting
window.wNumb = wNumb

import './plugin/floatlabel'

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
import axios from 'axios'

window.axios = axios

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

/**
 * Allows you to add data-method="METHOD to links to automatically inject a form
 * with the method on click
 *
 * Example: <a href="{{route('customers.destroy', $customer->id)}}"
 * data-method="delete" name="delete_item">Delete</a>
 *
 * Injects a form with that's fired on click of the link with a DELETE request.
 * Good because you don't have to dirty your HTML with delete forms everywhere.
 */
window.addDeleteForms = function () {
  $('[data-method]')
    .append(function() {
      if (!$(this).find('form').length > 0) {
        return (
          `${'\n' + "<form action='"}${$(this).attr(
            'href'
          )}' method='POST' name='delete_item' style='display:none'>\n` +
          `   <input type='hidden' name='_method' value='${$(this).attr('data-method')}'>\n` +
          `   <input type='hidden' name='_token' value='${$('meta[name="_token"]').attr(
            'content'
          )}'>\n` +
          '</form>\n'
        )
      }
      return ''
    })
    .removeAttr('href')
    .attr('style', 'cursor:pointer;')
    .attr('onclick', '$(this).find("form").submit();')
}

/**
 * Place any jQuery/helper plugins in here.
 */
window.addEventListener('load', () => {
  /**
   * Ensure that tooltips/popovers are registered when opening bootstrap modals
   * Some modals in our platform ajax call a blade view into them, so they fail to include the master layout
   * containing the tooltip/popover js
   */
  $('.modal').on('shown.bs.modal', () => {
    $('[data-toggle="tooltip"]').tooltip({
      container: 'body',
    })
    $('body').popover({
      selector: '[data-toggle="popover"]',
    })
  })

  /**
   * Place the CSRF token as a header on all pages for access in AJAX requests
   */
  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content'),
    },
  })

  /**
   * Add the data-method="delete" forms to all delete links
   */
  window.addDeleteForms()

  const swalConfirm = function(form, dataBearer) {
    const cancel = dataBearer.attr('data-trans-button-cancel')
      ? dataBearer.attr('data-trans-button-cancel')
      : 'Cancel'
    const confirm = dataBearer.attr('data-trans-button-confirm')
      ? dataBearer.attr('data-trans-button-confirm')
      : 'Yes'
    const title = dataBearer.attr('data-trans-title')
      ? dataBearer.attr('data-trans-title')
      : 'Warning'
    const text = dataBearer.attr('data-trans-text')
      ? dataBearer.attr('data-trans-text')
      : 'Are you sure you want to do this ?'
    const type = dataBearer.attr('data-confirm-type')
      ? dataBearer.attr('data-confirm-type').toLowerCase()
      : 'warning'
    const typeColors = {
      primary: '#3c8dbc',
      danger: '#dd4b39',
      success: '#00a65a',
      info: '#00c0ef',
      warning: '#f39c12',
    }
    swal(
      {
        title,
        text,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: cancel,
        confirmButtonColor: typeColors[type] ?? '#f39c12',
        confirmButtonText: confirm,
        closeOnConfirm: true,
      },
      (confirmed) => {
        if (confirmed) form.submit()
      }
    )
  }

  /**
   * Generic way of adding sweet alert confirmations to forms.
   *
   * Usage:
   * 1) add your button/anchor tag with onclick="$('form#my-form').trigger('submit');"
   * 2) add your form with id="my-form" and name="fully_decoupled"
   */
  $('body').on('submit', 'form[name=fully_decoupled]', function(e) {
    e.preventDefault()
    const form = this
    const link = $(e.target)

    swalConfirm(form, link)
  })
  /**
   * Generic confirm form delete using Sweet Alert
   *
   * @deprecated
   */
  $('body').on('submit', 'form[name=delete_item]', function(e) {
    e.preventDefault()
    const form = this
    const link = $('a[data-method="delete"]')

    swalConfirm(form, link)
  })
  /**
   * @deprecated
   */
  $('body').on('submit', 'form.needs-confirm', function(e) {
    e.preventDefault()
    const form = this
    const link = $('*[data-confirm-bearer]')

    swalConfirm(form, link)
  })

  /**
   * Bind all bootstrap tooltips
   */
  $('[data-toggle="tooltip"]').tooltip({
    container: 'body',
  })

  /**
   * Enable all bootstrap dropdowns
   */
  $('[data-toggle="dropdown"]').dropdown()

  $.fn.selectpicker.Constructor.DEFAULTS.noneSelectedText =
    typeof $t !== 'undefined' ? $t('Nothing selected') : 'Nothing selected'

  $('.selectpicker').selectpicker()

  /**
   * Bind all bootstrap popovers
   */
  // $("[data-toggle=\"popover\"]").popover();

  /**
   * This closes the popover when its clicked away from
   */
  $('body').on('click', (e) => {
    $('[data-toggle="popover"]').each(function() {
      if (
        !$(this).is(e.target) &&
        $(this).has(e.target).length === 0 &&
        $('.popover').has(e.target).length === 0
      ) {
        $(this).popover('hide')
      }
    })
  })

})
